import api from './api';

export const documentService = {
  getDocuments: async (params = {}) => {
    const query = new URLSearchParams({ t: Date.now(), ...params }).toString();
    const response = await api.get(`/documents?${query}`);
    return response.data;
  },
  getDocument: async (id) => {
    const response = await api.get(`/documents/${id}?t=${Date.now()}`);
    return response.data;
  },
  uploadDocument: async (formData) => {
    const response = await api.post('/documents/upload', formData);
    return response.data;
  },
  updateDocument: async (id, data) => {
    // If data is FormData, send as is. If regular object, axios sends as JSON.
    const response = await api.patch(`/documents/${id}`, data);
    return response.data;
  },
  updatePermissions: async (id, data) => {
    const response = await api.put(`/documents/${id}/permissions`, data);
    return response.data;
  },
  deleteDocument: async (id) => {
    const response = await api.delete(`/documents/${id}`);
    return response.data;
  },
  createBlankDocument: async (data) => {
    const response = await api.post('/documents/create-blank', data);
    return response.data;
  },
};
